import { render } from "./ConfiguracoesPage.vue?vue&type=template&id=3bc46aca&scoped=true"
import script from "./ConfiguracoesPage.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesPage.vue?vue&type=script&lang=js"

import "./ConfiguracoesPage.vue?vue&type=style&index=0&id=3bc46aca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc46aca"]])

export default __exports__